import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useCart } from "@/context/CartContext";
import { money } from "@/config";

export default function CartPage() {
  const { items, updateQty, removeItem, subtotal } = useCart();
  const navigate = useNavigate();

  if (items.length === 0)
    return (
      <div className="mx-auto max-w-3xl px-4 py-32 text-center" data-testid="cart-page-empty">
        <p className="font-script font-semibold text-4xl text-clay">Tu carrito está vacío...</p>
        <p className="mt-2 text-clay">¡Pero tu mesa no tiene por qué estarlo!</p>
        <Button asChild className="mt-8 rounded-full bg-habanero px-8 py-6 font-bold text-white hover:bg-habanero-dark" data-testid="cart-page-shop-button">
          <Link to="/tienda">Ver la tienda</Link>
        </Button>
      </div>
    );

  return (
    <div className="mx-auto max-w-4xl px-4 py-16 sm:px-8" data-testid="cart-page">
      <h1 className="font-script text-4xl font-semibold text-cocoa">Tu carrito</h1>
      <div className="mt-10 space-y-6">
        {items.map((i) => (
          <div key={`${i.slug}-${i.variant_id}`} className="flex gap-4 rounded-2xl border border-sand bg-white p-4" data-testid={`cart-page-item-${i.slug}-${i.variant_id}`}>
            <img src={i.image} alt={i.name} className="h-20 w-20 rounded-xl border border-sand object-cover" />
            <div className="flex flex-1 flex-col">
              <div className="flex items-start justify-between">
                <div>
                  <p className="font-bold text-cocoa">{i.name}</p>
                  <p className="text-sm text-clay">{i.variant_label}</p>
                </div>
                <button data-testid={`cart-page-remove-${i.slug}-${i.variant_id}`} aria-label={`Quitar ${i.name}`} className="text-clay hover:text-destructive" onClick={() => removeItem(i.slug, i.variant_id)}>
                  <Trash2 size={18} />
                </button>
              </div>
              <div className="mt-auto flex items-center justify-between">
                <div className="flex items-center gap-3 rounded-full border border-sand px-2 py-1">
                  <button data-testid={`cart-page-minus-${i.slug}-${i.variant_id}`} aria-label="Disminuir" className="p-1 text-clay hover:text-habanero" onClick={() => updateQty(i.slug, i.variant_id, i.qty - 1)}>
                    <Minus size={14} />
                  </button>
                  <span className="min-w-5 text-center text-sm font-bold">{i.qty}</span>
                  <button data-testid={`cart-page-plus-${i.slug}-${i.variant_id}`} aria-label="Aumentar" className="p-1 text-clay hover:text-habanero" onClick={() => updateQty(i.slug, i.variant_id, i.qty + 1)}>
                    <Plus size={14} />
                  </button>
                </div>
                <span className="font-display text-lg font-bold text-cocoa">{money(i.price * i.qty)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <Separator className="my-8 bg-sand" />
      <div className="flex items-center justify-between">
        <span className="font-semibold text-clay">Subtotal (envío se calcula en el checkout)</span>
        <span className="font-display text-2xl font-bold text-cocoa" data-testid="cart-page-subtotal">{money(subtotal)}</span>
      </div>
      <Button
        data-testid="cart-page-checkout-button"
        className="mt-6 w-full rounded-full bg-habanero py-6 text-base font-bold text-white hover:bg-habanero-dark"
        onClick={() => navigate("/checkout")}
      >
        Continuar al checkout
      </Button>
    </div>
  );
}
